import { Component, AfterViewInit,ViewChild, OnInit, ɵConsole } from '@angular/core';
import { MessageclientService } from '../../../../service/messageclient.service';
import { WebParameterContext } from '../../../../model/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { NativeService } from 'src/service/native.service';
import { GridBaseCase } from '../../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from '../../../basecase';
declare var app;
@Component({
  selector: 'app-approval-selection-management',
  templateUrl: './approval-selection-management.component.html',
  styleUrls: ['./approval-selection-management.component.scss']
})
export class ApprovalSelectionManagementComponent extends GridBaseCase implements AfterViewInit, OnInit  {
  searchValue:string = null;//查询内容
  month: any = new Date();
  proltype:any; // 审批类型
  dataArrayList: Array<any> = [];
  RecordCount: Number = 0;//列表总数量
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  constructor(
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    private platform: Platform,
    private http: HttpCustomerService,
    private router: Router,
    private native:NativeService,
    public com: CommonService,
    public baseService: BaseCase,
  ) {
    super();
    this.month = this.com.getNow;
    this.baseService.FixedSubmitBtn.configName = "approvalselectionmanagement";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "批量驳回";
    this.baseService.FixedSubmitBtn.type = 11;

   }
  ngAfterViewInit() {
    
  }
    loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber){
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get("id");
    if(id){
      id=id.split("&")[0];
    }
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
  
    body.ConfigName="TBScheduleNormalXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody = {};
    // body.RequestBody["a_SNStartDate"] =that.com.BetweenDate(that.month,that.month);
    body.RequestBody["a_SNStartDate"] =that.com.BetweenDate("2020-05-01","2020-05-31");
    body.RequestBody["a_FK_SystemUser_ID"] = id;
    // body.RequestBody["a_FK_TBScheduleType_ID"] = "";

    if(that.searchValue){
      // body.RequestBody["uar_name"] = that.searchValue.trim();
    }
    // if(that.searchValue){
    //   let selectItem = that.element.selectItemList.selectItem;
    //   if(selectItem.length > 0){
    //     selectItem.forEach(item=>{
    //       if(item.elementType && item.elementType=="Search") {
    //         body.RequestBody[item.field] = that.com.LikeSearch(that.searchValue.trim());
    //       }
    //     })
    //   }
    // }
    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
    };
    that.com.SaveSearchInfo(_searchObj);
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      console.log("1008611");
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.dataArrayList=data.Status.Datas;
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
  // 搜索条件
  serarEvent(e,type:string = 'type'){
    
  }
  // 日期查询
  EventDateTimeClick(){
    console.log("测试1");
    let that = this;
    console.log(that.month);
    let _obj = {
      value:that.month,
      format:"yyyymmdd"
    };
    that.native.IosselectDateTime(_obj).then(data=>{
     that.month=that.formatDate(data.value);
      console.log("测试");
    }).catch(eror=>{
    console.log(eror);
      });
  }
  formatDate(date){
    if(date){
      let _date = new Date(date.replace(/-/g,"/"));
      let _y = _date.getFullYear();
      let _m = _date.getMonth()+1;
      let _d = _date.getDate();
      return _y + "-" + (_m < 10?"0"+_m:_m) + "-"+(_d < 10? "0"+_d:_d);
    }else{
      return date;
    }
  }
  goBack(){
    this.com.goBack();
  }
   //审批状态改变
   changeTypeSelect(e){
     console.log(e);
     this.proltype=e.target.value;
   }
  //  全选e
  EventClickCehckedpro(){
     console.log("q全选");
  }
  EventSurepro(){
    console.log("提交");
  }
}
